window.setMap = function (id, latitude, longitude) {
    var pos = { lat: latitude, lng: longitude };
    var map = new google.maps.Map(document.getElementById(id), {
        center: pos,
        maptype: google.maps.MapTypeId.ROADMAP,
        region: 'US',
        zoom: 12,
        scrollWheelZoom: false,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        disableDefaultUI: true,
    });
    var marker = new google.maps.Marker({
        position: pos,
        map: map
    });
    marker.setMap(map);
}

$(document).ready(function () {
    var mapId = 'create-mission-map';
    $('.geolocate').on('click', function () {
        var data = {
            address1: $('#locationAddress').val(),
            address2: $('#locationAddress2').val(),
            city: $('#locationCity').val(),
            country_id: $('#locationCountry').val(),
            country: $('#locationCountry :selected').html(),
            state_id: $('#state').val(),
            state: $('#state :selected').html(),
            zip: $('#locationZip').val(),
        }
        var addressString = `${data.address1} ${data.address2} ${data.city} ${data.country} ${data.state} ${data.zip}`;
        data.address = addressString;
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: data.address }, function (results, status) {
            if (status === 'OK') {
                var latitude = results[0].geometry.location.lat();
                latitude = parseFloat(parseFloat(latitude).toFixed(6));
                var longitude = results[0].geometry.location.lng();
                longitude = parseFloat(parseFloat(longitude).toFixed(6));
                $('#latitude').val(latitude);
                $('#longitude').val(longitude);
                setMap(mapId, latitude, longitude);
            } else {
                errorToast(`Geocode not successful: ${results}`);
            }
        });
    });

    $('#latitude, #longitude').on('change', function () {
        var latitude = parseFloat($('#latitude').val());
        var longitude = parseFloat($('#longitude').val());
        if (!latitude || !longitude) return;
        if (!isNaN(latitude) && !isNaN(longitude)) {
            setMap(mapId, latitude, longitude);
        } else {
            errorToast(`Unable to parse latitude and longitude`);
        }
    });


});
